import s from "react";
import { useTranslation as i, Translation as a } from "react-i18next";
import d from "hoist-non-react-statics";
import h from "i18next";
import u from "i18next-browser-languagedetector";
const m = "Cancelar", p = "Close", w = "Descartar", C = "Pronto", S = "Baixar", T = "Próximo", $ = "Compartilhar", A = "limpar", y = "Mostrando linhas 1-{{rows}} de {{total}}", g = "carregando", x = "necessário", b = "retry", D = "{{selectedCount}} selecionado(s)", f = "Opções selecionadas: {{selectedOptionText}}", k = "{{selected}} de  selecionado({{total}}s)", F = "success", P = {
  "Add Another...": "Adicionar outro...",
  "Add Section to Presentation": "Adicionar seção à apresentação",
  "Add to Presentation": "Adicionar à apresentação",
  Cancel: m,
  Close: p,
  "Close modal": "Fechar modal",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "Não foi possível encontrar nenhum resultado para {{term}}.",
  "Deselect All": "Desmarcar tudo",
  Dismiss: w,
  Done: C,
  Download: S,
  "Filter...": "Filtrar...",
  "Go back": "Voltar",
  "Got it": "Entendido",
  "Jump to Section": "Ir para seção",
  Next: T,
  "None Selected": "Nenhum selecionado",
  "Oops!": "Oops!",
  "Please retry.": "Please retry.",
  "Search...": "Pesquisar...",
  "Select All": "Selecionar tudo",
  Share: $,
  "Show Fewer Filter Chips": "Mostrar menos chips de filtro",
  "Show More Filter Chips": "Mostrar mais chips de filtro",
  "Start Typing...": "Comece a digitar...",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: A,
  "clear all": "limpar tudo",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "fechar “ir para seção”",
  dataTableRows: y,
  "dismiss notification": "dismiss notification",
  "load more": "carregar mais",
  loading: g,
  "open jump to section": "abrir “ir para seção”",
  required: x,
  retry: b,
  selectedCountText: D,
  selectedOptionsText: f,
  selectedTotalText: k,
  "show next": "mostrar próximo",
  "show previous": "mostrar anterior",
  success: F,
  "view all": "ver todos",
  "view more": "ver mais",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} Algo deu errado. {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, v = "Cancel", O = "Close", N = "Dismiss", j = "Done", G = "Download", q = "Next", L = "Share", R = "clear", M = "Showing rows 1-{{rows}} of {{total}}", J = "loading", _ = "required", z = "retry", E = "{{selectedCount}} selected", W = "Selected options: {{selectedOptionText}}", Z = "{{selected}} of {{total}} selected", V = "success", I = {
  "Add Another...": "Add Another...",
  "Add Section to Presentation": "Add Section to Presentation",
  "Add to Presentation": "Add to Presentation",
  Cancel: v,
  Close: O,
  "Close modal": "Close modal",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "Could not find any results for {{term}}.",
  "Deselect All": "Deselect All",
  Dismiss: N,
  Done: j,
  Download: G,
  "Filter...": "Filter...",
  "Go back": "Go back",
  "Got it": "Got it",
  "Jump to Section": "Jump to Section",
  Next: q,
  "None Selected": "None Selected",
  "Oops!": "Oops!",
  "Please retry.": "Please retry.",
  "Search...": "Search...",
  "Select All": "Select All",
  Share: L,
  "Show Fewer Filter Chips": "Show Fewer Filter Chips",
  "Show More Filter Chips": "Show More Filter Chips",
  "Start Typing...": "Start Typing...",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: R,
  "clear all": "clear all",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "close jump to section",
  dataTableRows: M,
  "dismiss notification": "dismiss notification",
  "load more": "load more",
  loading: J,
  "open jump to section": "open jump to section",
  required: _,
  retry: z,
  selectedCountText: E,
  selectedOptionsText: W,
  selectedTotalText: Z,
  "show next": "show next",
  "show previous": "show previous",
  success: V,
  "view all": "view all",
  "view more": "view more",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} Something went wrong. {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, U = "Cancel", B = "Close", H = "Dismiss", K = "Done", Q = "Download", X = "Next", Y = "Share", ee = "clear", te = "Showing rows 1-{{rows}} of {{total}}", oe = "loading", se = "required", ne = "retry", le = "{{selectedCount}} seleccionado(s)", re = "Selected options: {{selectedOptionText}}", ce = "{{selected}} of {{total}} selected", ie = "success", ae = {
  "Add Another...": "Add Another...",
  "Add Section to Presentation": "Add Section to Presentation",
  "Add to Presentation": "Add to Presentation",
  Cancel: U,
  Close: B,
  "Close modal": "Close modal",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "Could not find any results for {{term}}.",
  "Deselect All": "Deselect All",
  Dismiss: H,
  Done: K,
  Download: Q,
  "Filter...": "Filtrar...",
  "Go back": "Go back",
  "Got it": "Got it",
  "Jump to Section": "Jump to Section",
  Next: X,
  "None Selected": "None Selected",
  "Oops!": "Oops!",
  "Please retry.": "Please retry.",
  "Search...": "Search...",
  "Select All": "Select All",
  Share: Y,
  "Show Fewer Filter Chips": "Show Fewer Filter Chips",
  "Show More Filter Chips": "Show More Filter Chips",
  "Start Typing...": "Start Typing...",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: ee,
  "clear all": "borrar todo",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "close jump to section",
  dataTableRows: te,
  "dismiss notification": "dismiss notification",
  "load more": "load more",
  loading: oe,
  "open jump to section": "open jump to section",
  required: se,
  retry: ne,
  selectedCountText: le,
  selectedOptionsText: re,
  selectedTotalText: ce,
  "show next": "show next",
  "show previous": "show previous",
  success: ie,
  "view all": "view all",
  "view more": "view more",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} Something went wrong. {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, de = "Abbrechen", he = "Close", ue = "Verwerfen", me = "Fertig", pe = "Herunterladen", we = "Weiter", Ce = "Teilen", Se = "Entfernen", Te = "Zeilen 1–{{rows}} von {{total}} anzeigen", $e = "Wird geladen …", Ae = "erforderlich", ye = "retry", ge = "{{selectedCount}} ausgewählt", xe = "Ausgewählte Optionen: {{selectedOptionText}}", be = "{{selected}} von {{total}} ausgewählt", De = "success", fe = {
  "Add Another...": "Weitere hinzufügen …",
  "Add Section to Presentation": "Abschnitt zur Präsentation hinzufügen",
  "Add to Presentation": "Zur Präsentation hinzufügen",
  Cancel: de,
  Close: he,
  "Close modal": "Dialogfeld schließen",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "Keine Ergebnisse für „{{term}}“ gefunden.",
  "Deselect All": "Auswahl aufheben",
  Dismiss: ue,
  Done: me,
  Download: pe,
  "Filter...": "Filtern …",
  "Go back": "Zurück",
  "Got it": "Verstanden",
  "Jump to Section": "Zum Abschnitt gehen",
  Next: we,
  "None Selected": "Keine Auswahl getroffen",
  "Oops!": "Hoppla!",
  "Please retry.": "Please retry.",
  "Search...": "Suchen …",
  "Select All": "Alle auswählen",
  Share: Ce,
  "Show Fewer Filter Chips": "Weniger Filteroptionen anzeigen",
  "Show More Filter Chips": "Mehr Filteroptionen anzeigen",
  "Start Typing...": "Text eingeben …",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: Se,
  "clear all": "Alle entfernen",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "„Zum Abschnitt gehen“ schließen",
  dataTableRows: Te,
  "dismiss notification": "dismiss notification",
  "load more": "Mehr laden",
  loading: $e,
  "open jump to section": "„Zum Abschnitt gehen“ öffnen",
  required: Ae,
  retry: ye,
  selectedCountText: ge,
  selectedOptionsText: xe,
  selectedTotalText: be,
  "show next": "Nächste anzeigen",
  "show previous": "Letzte anzeigen",
  success: De,
  "view all": "Alle anzeigen",
  "view more": "Mehr anzeigen",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} Etwas ist schief gelaufen. {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, ke = "取消", Fe = "Close", Pe = "撤销", ve = "完成", Oe = "下载", Ne = "下一个", je = "数量占比", Ge = "清除", qe = "显示共{{total}}行的第1-{{rows}}行", Le = "正在加载", Re = "必选项", Me = "retry", Je = "已选中的{{selectedCount}}个", _e = "已选中的选项：{{selectedOptionText}}", ze = "已选中{{total}}个中的{{selected}}个", Ee = "success", n = {
  "Add Another...": "添加另一个……",
  "Add Section to Presentation": "在演示文稿中添加章节",
  "Add to Presentation": "添加到演示文稿中",
  Cancel: ke,
  Close: Fe,
  "Close modal": "关闭弹窗",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "找不到任何有关{{term}}的结果。",
  "Deselect All": "全部不选",
  Dismiss: Pe,
  Done: ve,
  Download: Oe,
  "Filter...": "筛选……",
  "Go back": "返回",
  "Got it": "了解",
  "Jump to Section": "跳转到章节",
  Next: Ne,
  "None Selected": "未选中",
  "Oops!": "哎呀！",
  "Please retry.": "Please retry.",
  "Search...": "搜索……",
  "Select All": "全部选择",
  Share: je,
  "Show Fewer Filter Chips": "减少显示的筛选标签数量",
  "Show More Filter Chips": "增加显示的筛选标签数量",
  "Start Typing...": "开始输入……",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: Ge,
  "clear all": "全部清除",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "关闭“跳转到章节”",
  dataTableRows: qe,
  "dismiss notification": "dismiss notification",
  "load more": "加载更多",
  loading: Le,
  "open jump to section": "打开“跳转到章节”",
  required: Re,
  retry: Me,
  selectedCountText: Je,
  selectedOptionsText: _e,
  selectedTotalText: ze,
  "show next": "显示下一个",
  "show previous": "显示前一个",
  success: Ee,
  "view all": "查看所有",
  "view more": "查看更多",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}}出现错误。{{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, We = "Annuler", Ze = "Close", Ve = "Dismiss", Ie = "Done", Ue = "Download", Be = "Next", He = "Share", Ke = "clear", Qe = "Showing rows 1-{{rows}} of {{total}}Rows", Xe = "loading", Ye = "required", et = "retry", tt = "{{selectedCount}} sélectionné(e)(s)", ot = "Selected options: {{selectedOptionText}}", st = "{{selected}} of {{total}} selected", nt = "success", lt = {
  "Add Another...": "Add Another...",
  "Add Section to Presentation": "Add Section to Presentation",
  "Add to Presentation": "Add to Presentation",
  Cancel: We,
  Close: Ze,
  "Close modal": "Close modal",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "Could not find any results for {{term}}.",
  "Deselect All": "Deselect All",
  Dismiss: Ve,
  Done: Ie,
  Download: Ue,
  "Filter...": "Filtrer...",
  "Go back": "Go back",
  "Got it": "Got it",
  "Jump to Section": "Jump to Section",
  Next: Be,
  "None Selected": "None Selected",
  "Oops!": "Oops!",
  "Please retry.": "Please retry.",
  "Search...": "Search...",
  "Select All": "Select All",
  Share: He,
  "Show Fewer Filter Chips": "Show Fewer Filter Chips",
  "Show More Filter Chips": "Show More Filter Chips",
  "Start Typing...": "Start Typing...",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: Ke,
  "clear all": "tout effacer",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "close jump to section",
  dataTableRows: Qe,
  "dismiss notification": "dismiss notification",
  "load more": "load more",
  loading: Xe,
  "open jump to section": "open jump to section",
  required: Ye,
  retry: et,
  selectedCountText: tt,
  selectedOptionsText: ot,
  selectedTotalText: st,
  "show next": "show next",
  "show previous": "show previous",
  success: nt,
  "view all": "view all",
  "view more": "view more",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} Something went wrong. {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, rt = "ยกเลิก", ct = "Close", it = "ยกเลิก", at = "เสร็จสิ้น", dt = "ดาวน์โหลด", ht = "ถัดไป", ut = "แชร์", mt = "ยกเลิก", pt = "แสดงแถว 1-{{rows}} จาก {{total}} ", wt = "กำลังโหลดข้อมูล", Ct = "ต้องการ", St = "retry", Tt = "{{selectedCount}} รายการ", $t = "ตัวเลือกที่เลือกไว้: {{selectedOptionText}}", At = "{{selected}} ใน {{total}} ตัวเลือกที่เลือกไว้", yt = "success", gt = {
  "Add Another...": "เพิ่มเติม...",
  "Add Section to Presentation": "เพิ่มส่วนนี้ไปยังการนำเสนอข้อมูล",
  "Add to Presentation": "เพิ่มไปยังการนำเสนอข้อมูล",
  Cancel: rt,
  Close: ct,
  "Close modal": "ปิดข้อความนี้",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "ไม่พบผลลัพธ์สำหรับ {{term}}",
  "Deselect All": "ยกเลิกคำสั่งที่เลือกไว้ทั้งหมด",
  Dismiss: it,
  Done: at,
  Download: dt,
  "Filter...": "ตัวกรอง...",
  "Go back": "ย้อนกลับ",
  "Got it": "รับทราบ",
  "Jump to Section": "ข้ามไปยังเนื้อหาส่วนต่อไป",
  Next: ht,
  "None Selected": "ไม่พบการเลือก",
  "Oops!": "อุ๊บส์!",
  "Please retry.": "Please retry.",
  "Search...": "ค้นหา...",
  "Select All": "เลือกทั้งหมด",
  Share: ut,
  "Show Fewer Filter Chips": "แสดงตัวกรองน้อยลง",
  "Show More Filter Chips": "แสดงตัวกรองเพิ่มเติม",
  "Start Typing...": "เริ่มพิมพ์...",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: mt,
  "clear all": "ยกเลิกทั้งหมด",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "ปิดตัวเลือกการข้ามไปยังเนื้อหาส่วนต่อไป",
  dataTableRows: pt,
  "dismiss notification": "dismiss notification",
  "load more": "โหลดเพิ่มเติม",
  loading: wt,
  "open jump to section": "เปิดตัวเลือกการข้ามไปยังเนื้อหาส่วนต่อไป",
  required: Ct,
  retry: St,
  selectedCountText: Tt,
  selectedOptionsText: $t,
  selectedTotalText: At,
  "show next": "แสดงข้อมูลถัดไป",
  "show previous": "แสดงข้อมูลก่อนหน้า",
  success: yt,
  "view all": "ดูทั้งหมด",
  "view more": "ดูเพิ่มเติม",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}}มีความขัดข้องบางประการ{{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, xt = "Cancel", bt = "Close", Dt = "Dismiss", ft = "Done", kt = "Download", Ft = "Next", Pt = "Share", vt = "clear", Ot = "Showing rows 1-{{rows}} of {{total}}", Nt = "loading", jt = "required", Gt = "retry", qt = "{{selectedCount}} dipilih", Lt = "Selected options: {{selectedOptionText}}", Rt = "{{selected}} of {{total}} selected", Mt = "success", Jt = {
  "Add Another...": "Add Another...",
  "Add Section to Presentation": "Add Section to Presentation",
  "Add to Presentation": "Add to Presentation",
  Cancel: xt,
  Close: bt,
  "Close modal": "Close modal",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "Could not find any results for {{term}}.",
  "Deselect All": "Deselect All",
  Dismiss: Dt,
  Done: ft,
  Download: kt,
  "Filter...": "Filter...",
  "Go back": "Go back",
  "Got it": "Got it",
  "Jump to Section": "Jump to Section",
  Next: Ft,
  "None Selected": "None Selected",
  "Oops!": "Oops!",
  "Please retry.": "Please retry.",
  "Search...": "Search...",
  "Select All": "Select All",
  Share: Pt,
  "Show Fewer Filter Chips": "Show Fewer Filter Chips",
  "Show More Filter Chips": "Show More Filter Chips",
  "Start Typing...": "Start Typing...",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: vt,
  "clear all": "hapus semua",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "close jump to section",
  dataTableRows: Ot,
  "dismiss notification": "dismiss notification",
  "load more": "load more",
  loading: Nt,
  "open jump to section": "open jump to section",
  required: jt,
  retry: Gt,
  selectedCountText: qt,
  selectedOptionsText: Lt,
  selectedTotalText: Rt,
  "show next": "show next",
  "show previous": "show previous",
  success: Mt,
  "view all": "view all",
  "view more": "view more",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} Something went wrong. {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, _t = "Cancel", zt = "Close", Et = "Dismiss", Wt = "Done", Zt = "Download", Vt = "Next", It = "Share", Ut = "clear", Bt = "Showing rows 1-{{rows}} of {{total}}", Ht = "loading", Kt = "required", Qt = "retry", Xt = "{{selectedCount}} selezionato/i", Yt = "Selected options: {{selectedOptionText}}", eo = "{{selected}} of {{total}} selected", to = "success", oo = {
  "Add Another...": "Add Another...",
  "Add Section to Presentation": "Add Section to Presentation",
  "Add to Presentation": "Add to Presentation",
  Cancel: _t,
  Close: zt,
  "Close modal": "Close modal",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "Could not find any results for {{term}}.",
  "Deselect All": "Deselect All",
  Dismiss: Et,
  Done: Wt,
  Download: Zt,
  "Filter...": "Filtra...",
  "Go back": "Go back",
  "Got it": "Got it",
  "Jump to Section": "Jump to Section",
  Next: Vt,
  "None Selected": "None Selected",
  "Oops!": "Oops!",
  "Please retry.": "Please retry.",
  "Search...": "Search...",
  "Select All": "Select All",
  Share: It,
  "Show Fewer Filter Chips": "Show Fewer Filter Chips",
  "Show More Filter Chips": "Show More Filter Chips",
  "Start Typing...": "Start Typing...",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: Ut,
  "clear all": "cancella tutto",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "close jump to section",
  dataTableRows: Bt,
  "dismiss notification": "dismiss notification",
  "load more": "load more",
  loading: Ht,
  "open jump to section": "open jump to section",
  required: Kt,
  retry: Qt,
  selectedCountText: Xt,
  selectedOptionsText: Yt,
  selectedTotalText: eo,
  "show next": "show next",
  "show previous": "show previous",
  success: to,
  "view all": "view all",
  "view more": "view more",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} Something went wrong. {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, so = "キャンセル", no = "Close", lo = "閉じる", ro = "完了", co = "ダウンロード", io = "次へ", ao = "共有", ho = "クリア", uo = "{{total}}件中1-{{rows}}件を表示", mo = "読み込み中", po = "必須", wo = "retry", Co = "{{selectedCount}}つ選択中", So = "選択中のオプション：{{selectedOptionText}}", To = "{{total}}つ中{{selected}}つ選択中", $o = "success", Ao = {
  "Add Another...": "さらに追加する",
  "Add Section to Presentation": "プレゼンテーションにセクションを追加",
  "Add to Presentation": "プレゼンテーションに追加",
  Cancel: so,
  Close: no,
  "Close modal": "ウィンドウを閉じる",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "{{term}}の検索結果が見つかりません。",
  "Deselect All": "全て選択解除",
  Dismiss: lo,
  Done: ro,
  Download: co,
  "Filter...": "絞り込む",
  "Go back": "戻る",
  "Got it": "了解",
  "Jump to Section": "セクションに移動する",
  Next: io,
  "None Selected": "選択なし",
  "Oops!": "エラー",
  "Please retry.": "Please retry.",
  "Search...": "検索する",
  "Select All": "全て選択",
  Share: ao,
  "Show Fewer Filter Chips": "フィルターチップの表示を隠す",
  "Show More Filter Chips": "フィルターチップをさらに表示",
  "Start Typing...": "入力する",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: ho,
  "clear all": "全てクリア",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "セクション移動を閉じる",
  dataTableRows: uo,
  "dismiss notification": "dismiss notification",
  "load more": "さらに表示",
  loading: mo,
  "open jump to section": "セクション移動を開く",
  required: po,
  retry: wo,
  selectedCountText: Co,
  selectedOptionsText: So,
  selectedTotalText: To,
  "show next": "次を表示",
  "show previous": "前を表示",
  success: $o,
  "view all": "全て見る",
  "view more": "さらに見る",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} 問題が発生しました。 {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, yo = "Cancel", go = "Close", xo = "Dismiss", bo = "Done", Do = "Download", fo = "Next", ko = "Share", Fo = "clear", Po = "Showing rows 1-{{rows}} of {{total}}", vo = "loading", Oo = "required", No = "retry", jo = "{{selectedCount}}개 선택됨", Go = "Selected options: {{selectedOptionText}}", qo = "{{selected}} of {{total}} selected", Lo = "success", Ro = {
  "Add Another...": "Add Another...",
  "Add Section to Presentation": "Add Section to Presentation",
  "Add to Presentation": "Add to Presentation",
  Cancel: yo,
  Close: go,
  "Close modal": "Close modal",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "Could not find any results for {{term}}.",
  "Deselect All": "Deselect All",
  Dismiss: xo,
  Done: bo,
  Download: Do,
  "Filter...": "필터...",
  "Go back": "Go back",
  "Got it": "Got it",
  "Jump to Section": "Jump to Section",
  Next: fo,
  "None Selected": "None Selected",
  "Oops!": "Oops!",
  "Please retry.": "Please retry.",
  "Search...": "Search...",
  "Select All": "Select All",
  Share: ko,
  "Show Fewer Filter Chips": "Show Fewer Filter Chips",
  "Show More Filter Chips": "Show More Filter Chips",
  "Start Typing...": "Start Typing...",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: Fo,
  "clear all": "모두 지우기",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "close jump to section",
  dataTableRows: Po,
  "dismiss notification": "dismiss notification",
  "load more": "load more",
  loading: vo,
  "open jump to section": "open jump to section",
  required: Oo,
  retry: No,
  selectedCountText: jo,
  selectedOptionsText: Go,
  selectedTotalText: qo,
  "show next": "show next",
  "show previous": "show previous",
  success: Lo,
  "view all": "view all",
  "view more": "view more",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} Something went wrong. {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, Mo = "Cancel", Jo = "Close", _o = "Dismiss", zo = "Done", Eo = "Download", Wo = "Next", Zo = "Share", Vo = "clear", Io = "Showing rows 1-{{rows}} of {{total}}", Uo = "loading", Bo = "required", Ho = "retry", Ko = "{{selectedCount}} được chọn", Qo = "Selected options: {{selectedOptionText}}", Xo = "{{selected}} of {{total}} selected", Yo = "success", es = {
  "Add Another...": "Add Another...",
  "Add Section to Presentation": "Add Section to Presentation",
  "Add to Presentation": "Add to Presentation",
  Cancel: Mo,
  Close: Jo,
  "Close modal": "Close modal",
  "Copy link": "Copy link",
  "Could not find any results for {{term}}.": "Could not find any results for {{term}}.",
  "Deselect All": "Deselect All",
  Dismiss: _o,
  Done: zo,
  Download: Eo,
  "Filter...": "Bộ lọc...",
  "Go back": "Go back",
  "Got it": "Got it",
  "Jump to Section": "Jump to Section",
  Next: Wo,
  "None Selected": "None Selected",
  "Oops!": "Oops!",
  "Please retry.": "Please retry.",
  "Search...": "Search...",
  "Select All": "Select All",
  Share: Zo,
  "Show Fewer Filter Chips": "Show Fewer Filter Chips",
  "Show More Filter Chips": "Show More Filter Chips",
  "Start Typing...": "Start Typing...",
  "The end date must be later than the start date.": "The end date must be later than the start date.",
  clear: Vo,
  "clear all": "xóa tất cả",
  "click to sort by this column": "click to sort by this column",
  "close jump to section": "close jump to section",
  dataTableRows: Io,
  "dismiss notification": "dismiss notification",
  "load more": "load more",
  loading: Uo,
  "open jump to section": "open jump to section",
  required: Bo,
  retry: Ho,
  selectedCountText: Ko,
  selectedOptionsText: Qo,
  selectedTotalText: Xo,
  "show next": "show next",
  "show previous": "show previous",
  success: Yo,
  "view all": "view all",
  "view more": "view more",
  "{{errorLeader}} Something went wrong. {{errorAction}}": "{{errorLeader}} Something went wrong. {{errorAction}}",
  "{{selected}} selected. Click to select {{unselected}}": "{{selected}} selected. Click to select {{unselected}}"
}, t = h.createInstance();
t.use(u).init({
  resources: {
    en: { mrui_translations: I },
    de: { mrui_translations: fe },
    es: { mrui_translations: ae },
    fr: { mrui_translations: lt },
    id: { mrui_translations: Jt },
    it: { mrui_translations: oo },
    ja: { mrui_translations: Ao },
    ko: { mrui_translations: Ro },
    pt: { mrui_translations: P },
    th: { mrui_translations: gt },
    vi: { mrui_translations: es },
    zh: { mrui_translations: n },
    "zh-hans": { mrui_translations: n }
  },
  detection: {
    order: [
      "querystring",
      "localStorage",
      "sessionStorage",
      "navigator",
      "htmlTag"
    ]
  },
  fallbackLng: "en",
  ns: ["mrui_translations"],
  defaultNS: "mrui_translations",
  keySeparator: !1,
  interpolation: {
    escapeValue: !1
  }
});
function rs(e) {
  const o = (l) => /* @__PURE__ */ s.createElement(a, { ns: "mrui_translations", i18n: t }, (r, { i18n: c }) => /* @__PURE__ */ s.createElement(e, { ...l, t: r, i18n: c }));
  return d(o, e), o.displayName = `WithMRUITranslations(${e.displayName || e.name || "Component"})`, o;
}
const cs = () => i("mrui_translations", { i18n: t }), is = (e) => {
  t.changeLanguage(e);
};
export {
  is as s,
  cs as u,
  rs as w
};
